import { defineMessages } from 'react-intl';

const messages = defineMessages({
  sectionTitle: {
    id: 'Section title',
    defaultMessage: 'Section title',
  },
  flagAlign: {
    id: 'Flag align',
    defaultMessage: 'Align',
  },
  copyrightText: {
    id: 'Image copyright',
    defaultMessage: 'Image copyright',
  },
});

const sliderSchemaEnhancer = ({ schema, formData, intl }) => {
  if (schema.fieldsets?.[0]) {
    const fs0 = schema.fieldsets[0];
    fs0.fields = ['sectionTitle', ...fs0.fields];
  }

  schema.properties = {
    ...(schema.properties || {}),
    sectionTitle: { title: intl.formatMessage(messages.sectionTitle) },
  };

  const slidesSchema = schema?.properties?.slides?.schema;
  if (slidesSchema?.fieldsets?.[0]) {
    const baseFields = slidesSchema.fieldsets[0].fields || [];

    const addField = (name) => {
      if (!baseFields.includes(name)) baseFields.push(name);
    };

    addField('flagAlign');
    addField('copyrightText');

    slidesSchema.properties = {
      ...(slidesSchema.properties || {}),
      flagAlign: {
        widget: 'inner_align',
        title: intl.formatMessage(messages.flagAlign),
        actions: ['left', 'right'],
        default: 'left',
      },
      copyrightText: {
        title: intl.formatMessage(messages.copyrightText),
        description:
          'Wird als Bildnachweis im Slide angezeigt (© Icon unten rechts).',
      },
    };

    slidesSchema.fieldsets[0].fields = baseFields;
  }

  return schema;
};

export default sliderSchemaEnhancer;
